let resumeData = {
  "name": "Ben Calvert",
  "role": "Senior Product Manager",
  "roleDescription": "I ship products that reach 20M+ families and make schools work better.",
  "linkedinId": "https://linkedin.com/in/benjamin-calvert-62978438/",
  "email": "mailto:benhcalvert@gmail.com",
  "socialLinks": [
    {
      "name": "linkedin",
      "url": "https://linkedin.com/in/benjamin-calvert-62978438/",
      "className": "fa fa-linkedin"
    },
    {
      "name": "github",
      "url": "https://github.com/BenHCalvert",
      "className": "fa fa-github"
    }
  ],
  "aboutme": "I'm a Senior Product Manager at ParentSquare, where I lead teams building the communication platform used by 20M+ families across U.S. school districts. I've shipped 0-to-1 products that quickly generated $1M+ in new ARR, pioneered an agentic AI product discovery process, and driven 70%+ reductions in support volume through better UX. Before product, I was an integration engineer and before that, I ran school operations . I think about problems from the code, the user, and the business all at once. Based in Boise, ID.",
  "address": "Boise, ID",
  "website": "https://github.com/BenHCalvert",
  "education": [
    {
      "UniversityName": "University of Denver",
      "specialization": "Certificate, Full-Stack Web Development",
      "MonthOfPassing": "Mar",
      "YearOfPassing": "2020"
    },
    {
      "UniversityName": "New York University",
      "specialization": "Bachelor of Arts: Economics, Minor: Italian",
      "MonthOfPassing": "May",
      "YearOfPassing": "2013"
    }
  ],
  "work": [
    {
      "CompanyName": "ParentSquare",
      "specialization": "Senior Product Manager",
      "MonthOfStarting": "Jun",
      "YearOfStarting": "2024",
      "MonthOfLeaving": "",
      "YearOfLeaving": "",
      "Achievements": "Formed and led a team focused on platform integrations and admin user experience, reducing ticket volume by >70% across many support categories in our first year. Drive ongoing product discovery through qualitative user interviews and quantitative analytics to prioritize roadmap initiatives. Present product strategy and feature updates at user conferences and to our advisory council, with sessions ranging from 15 to 200+ attendees."
    },
    {
      "CompanyName": "ParentSquare",
      "specialization": "Product Manager",
      "MonthOfStarting": "Oct",
      "YearOfStarting": "2022",
      "MonthOfLeaving": "Jun",
      "YearOfLeaving": "2024",
      "Achievements": "Led the end-to-end development and Go-to-Market strategy for Virtual Phone, generating $1M in new ARR within the first 20 months. Operationalized customer feedback channels through 1-on-1 interactions and product analytics to validate problems and solutions before development."
    },
    {
      "CompanyName": "ParentSquare",
      "specialization": "Data Integration Engineer",
      "MonthOfStarting": "Dec",
      "YearOfStarting": "2020",
      "MonthOfLeaving": "Oct",
      "YearOfLeaving": "2022",
      "Achievements": "Built robust integrations with external EdTech data management platforms (SIS), ensuring seamless data interoperability across districts. Led the technology evaluation phase for high-value sales prospects as the technical subject matter expert. Optimized implementation workflows by providing technical training and process improvements to Customer Success teams."
    },
    {
      "CompanyName": "STRIVE Prep - Sunnyside",
      "specialization": "Assistant Principal",
      "MonthOfStarting": "Jul",
      "YearOfStarting": "2018",
      "MonthOfLeaving": "Jun",
      "YearOfLeaving": "2020",
      "Achievements": "Co-led a successful middle school turnaround marked by a 16-34% increase in student achievement on semester 1 Language Arts midterms, a 12% increase in positive staff survey responses, and a 75% decrease in student suspensions. Directed cross-functional operations teams across Facilities, Tech, and Admin while managing budgets and resource allocation."
    },
    {
      "CompanyName": "KIPP New Jersey",
      "specialization": "Project Manager & Operations Manager",
      "MonthOfStarting": "Feb",
      "YearOfStarting": "2014",
      "MonthOfLeaving": "Nov",
      "YearOfLeaving": "2017",
      "Achievements": "Directed large-scale facility and construction projects for new site launches, managing vendors and timelines from initiation to delivery. Designed and launched an AmeriCorps teaching residency program, defining operational workflows and recruitment strategy from the ground up. Managed a $10M+ budget portfolio across Real Estate, CapEx, and IT infrastructure."
    }
  ],
  "skillsDescription": "Skills",
  "skills": [
    { "skillname": "AI/LLM Product Development" },
    { "skillname": "0-to-1 Product Launches" },
    { "skillname": "Product Analytics" },
    { "skillname": "User Research" },
    { "skillname": "Go-to-Market Strategy" },
    { "skillname": "Agile/Scrum" },
    { "skillname": "Figma" },
    { "skillname": "Pendo" },
    { "skillname": "Jira" },
    { "skillname": "SQL" },
    { "skillname": "Claude / Anthropic" },
    { "skillname": "JavaScript" },
    { "skillname": "API & Data Integrations" }
  ],
  "portfolio": [
    {
      "name": "Agentic Product Discovery",
      "description": "Designed and implemented an AI-powered product discovery workflow using Claude to synthesize user research, support data, and usage analytics — accelerating insight generation and reducing discovery cycle time for the ParentSquare product team.",
      "imgurl": "images/portfolio/agentic-discovery.png"
    },
    {
      "name": "Virtual Phone: 0-to-1 Launch",
      "description": "Led end-to-end product development and GTM for ParentSquare's Virtual Phone product — from discovery through launch — generating $1M+ in new ARR within 20 months.",
      "imgurl": "images/portfolio/virtual-phone.png"
    },
    {
      "name": "Admin UX & Integrations Platform",
      "description": "Formed and led a new product team focused on platform integrations and admin experience, reducing support ticket volume by 70%+ across key categories in the first year.",
      "imgurl": "images/portfolio/admin-ux.png"
    },
    {
      "name": "EdTech Data Integrations",
      "description": "Architected integrations with SIS platforms serving hundreds of school districts, ensuring seamless data interoperability and streamlining district onboarding as an integration engineer turned PM.",
      "imgurl": "images/portfolio/data-integrations.png"
    }
  ]
}

export default resumeData
